/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { FC, SVGProps } from 'react';

const HeadPhoneIcon: FC<SVGProps<SVGSVGElement> & { size?: number; color?: string }> = ({
  size = '20',
  color = '#7A7A7A',
  ...props
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.58028 14.5613C4.99298 15.2765 5.90758 15.5221 6.62272 15.1086C7.33623 14.6959 7.5811 13.783 7.1692 13.0678L5.91326 10.8924C5.50137 10.178 4.58758 9.9332 3.87326 10.3443L3.69731 10.4456C3.24893 10.7043 3.0219 11.237 3.17515 11.7315C3.44839 12.613 3.91461 13.5615 4.58028 14.5613Z"
        stroke="#7A7A7A"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.4242 14.5613C15.0114 15.2765 14.0968 15.5221 13.3817 15.1086C12.6682 14.6959 12.4233 13.783 12.8352 13.0678L14.0912 10.8924C14.5031 10.178 15.4168 9.9332 16.1312 10.3443L16.3072 10.4456C16.7555 10.7043 16.9825 11.237 16.8292 11.7315C16.5561 12.613 16.0898 13.5615 15.4242 14.5613Z"
        stroke="#7A7A7A"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.46924 17.4782C11.3827 17.4782 12.7392 17.8706 14.1103 15.3076"
        stroke="#7A7A7A"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.5276 12.5306C16.92 11.6476 17.1405 10.6665 17.1405 9.63675C17.1405 5.6946 13.9403 2.5 9.99809 2.5C6.0616 2.5 2.86133 5.6946 2.86133 9.63675C2.86133 10.5319 3.02674 11.3898 3.32754 12.1754"
        stroke="#7A7A7A"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default HeadPhoneIcon;
